import loadable from '@loadable/component';

const LoadableRecruitmentProfilePreview = loadable(() => import('./RecruitmentProfilePreview'));

export default LoadableRecruitmentProfilePreview;
